import { render, staticRenderFns } from "./AssetTransferList.vue?vue&type=template&id=f9b9409e"
import script from "./AssetTransferList.vue?vue&type=script&lang=js"
export * from "./AssetTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports